import { useCreateCommentMutation } from '../graphql/createComment.types'
import { useEditCommentMutation } from '../graphql/editComment.types'
import { useDeleteCommentMutation } from '../graphql/deleteComment.types'

export const useCommentActions = () => {
  const [createCommentMutation, { loading: isCreating }] = useCreateCommentMutation()
  const [editCommentMutation, { loading: isEditing }] = useEditCommentMutation()
  const [deleteCommentMutation, { loading: isDeleting }] = useDeleteCommentMutation()

  const loading = isCreating || isEditing || isDeleting
  return {
    createCommentMutation,
    editCommentMutation,
    deleteCommentMutation,
    loading
  }
}

